import React, { useEffect, useMemo, useState } from 'react';
import api from './../api';
import './componentsCss/ListaProcedimentosAssociados.css';
import useProceduresPartnersEspecific from '../views/partners/hooks/useProceduresPartnersEspecific.js';
import Loading from '../components/Loading';

export default function ListaProcedimentosAssociados({ id, partnerId }) {
    const { proceduresPartners, loadingPartners } = useProceduresPartnersEspecific(id, partnerId);
    const [procedures, setProcedures] = useState([])

    useEffect(() => {
        setProcedures(proceduresPartners?.procedures || []);
    }, [proceduresPartners])

    return (
        <div className='my-lista-procedimentos-associados'>
            <h2 className='my-lista-procedimentos-associados-h2'>Procedimentos Associados</h2>
            {loadingPartners && <Loading />}
            {procedures.length > 0 && (
                <div className='my-lista-procedimentos-associados-cards'>
                    {procedures.map((procedure) => (
                        <div className='my-lista-procedimentos-associados-card' key={procedure.id}>
                            <h5>{procedure.name}</h5>
                        </div>
                    ))}
                </div>
            )}
            {procedures.length === 0 && <p className='my-lista-procedimentos-associados-p'>Nenhum procedimento associado</p>}
        </div>
    );
}